import React, { useState } from "react";
import { Box, Tabs, TabList, TabPanels, Tab, TabPanel } from "@chakra-ui/react";
import AllUsersAnalytics from "./AllUsersAnalytics";
import IndividualUserAnalytics from "./IndividualUserAnalytics";

export default function UserAnalyticsTab({
  refreshNonce = 0,
  initialUserId = null,
  initialTimeWindow = "7d",
}) {
  const [timeWindow, setTimeWindow] = useState(initialTimeWindow);
  const [tabIndex, setTabIndex] = useState(initialUserId ? 1 : 0);
  const [selectedUserId, setSelectedUserId] = useState(initialUserId);

  const handleSelectUser = (userId) => {
    setSelectedUserId(userId);
    setTabIndex(1);
  };

  return (
    <Box>
      <Tabs
        variant="soft-rounded"
        colorScheme="blue"
        isLazy
        index={tabIndex}
        onChange={setTabIndex}
      >
        <TabList>
          <Tab>All Users</Tab>
          <Tab>Individual User</Tab>
        </TabList>
        <TabPanels>
          <TabPanel px={0}>
            <AllUsersAnalytics
              timeWindow={timeWindow}
              onTimeWindowChange={setTimeWindow}
              onSelectUser={handleSelectUser}
              refreshNonce={refreshNonce}
            />
          </TabPanel>
          <TabPanel px={0}>
            <IndividualUserAnalytics
              timeWindow={timeWindow}
              onTimeWindowChange={setTimeWindow}
              userId={selectedUserId}
              onUserIdChange={setSelectedUserId}
              refreshNonce={refreshNonce}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
}
